import { render, staticRenderFns } from "./XIcon.vue?vue&type=template&id=5a0f187c&"
import script from "./XIcon.vue?vue&type=script&lang=ts&"
export * from "./XIcon.vue?vue&type=script&lang=ts&"
import style0 from "./XIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5a0f187c', component.options)
    } else {
      api.reload('5a0f187c', component.options)
    }
    module.hot.accept("./XIcon.vue?vue&type=template&id=5a0f187c&", function () {
      api.rerender('5a0f187c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/XIcon.vue"
export default component.exports